import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'property-form-checkbox',
  templateUrl: './checkbox.component.html',
  imports: [FormlyModule, ReactiveFormsModule],
})
export class CheckboxComponent extends FieldType<FieldTypeConfig> {}
